import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-add',
  templateUrl: './about-add.component.html',
  styleUrls: ['./about-add.component.scss']
})
export class AboutAddComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
